import { LineItemType, EyeSide } from '../../../__generated__/sharedTypes.js';

const mapContactLensesLineItem = ({ sku , quantity , typeDetails  })=>{
    const { eyeSide , prescriptionExpiryDate , externalOptician  } = typeDetails;
    return {
        sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.CONTACTLENSES,
        typeDetails: {
            eyeSide: eyeSide === 'left' ? EyeSide.LEFT : EyeSide.RIGHT,
            prescriptionExpiryDate,
            externalOptician
        }
    };
};

export { mapContactLensesLineItem };
//# sourceMappingURL=contact-lenses.js.map
